import React from "react";
import styled from "styled-components/macro";
import { t } from "../../utils/intl";

export interface ILabelProps {
  labelTrKey?: string;
  className?: any;
  rowNumber?: number;
  handleLabelClick?: () => void;
}
export const Label: React.FC<ILabelProps> = props => {
  const { labelTrKey, handleLabelClick, className, rowNumber } = props || {};

  return (
    <LabelContainer className={className} onClick={handleLabelClick}>
      <LabelText>
        {rowNumber && rowNumber + "."} {labelTrKey && t(labelTrKey)}
      </LabelText>
    </LabelContainer>
  );
};

const LabelContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LabelText = styled.span`
  cursor: default;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.black};
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
  display: inline-block;
  width: 100%;
  text-overflow: ellipsis;
  > *:not(:last-child) {
    margin-right: 10px;
  }
`;
